module.exports = __webpack_public_path__ + "assets/preview_instagram.028f3422.svg";